import dayjs from 'dayjs';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { CLOCK } from '../../controllers/util-level/clock.controller';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { HHmm, humanizeDuration } from '../../utils/time.utils';
import DateRenderer from '../DateRenderer/DateRenderer';
import './SessionOrGroupTimeDisplay.scss';
var SessionOrGroupTimeDisplay = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get now() {
            return CLOCK.localNowDayjs;
        },
        get scheduledStartTimeMoment() {
            return p.model.timeScheduled ? dayjs.utc(p.model.timeScheduled).local() : null;
        },
        get actualStartTimeMoment() {
            return p.model.timeStarted ? dayjs.utc(p.model.timeStarted).local() : null;
        },
        get scheduledStartTimeFormatted() {
            var _a;
            return (_a = s.scheduledStartTimeMoment) === null || _a === void 0 ? void 0 : _a.format(HHmm);
        },
        get isThisYear() {
            var _a;
            return (_a = s.scheduledStartTimeMoment) === null || _a === void 0 ? void 0 : _a.isSame('', 'year');
        },
        get scheduledStartDateFormatted() {
            var _a;
            return (_a = s.scheduledStartTimeMoment) === null || _a === void 0 ? void 0 : _a.format('D MMMM');
        },
        get isToday() {
            var _a;
            return (_a = s.scheduledStartTimeMoment) === null || _a === void 0 ? void 0 : _a.isSame('', 'day');
        },
        get isTomorrow() {
            return s.scheduledStartTimeMoment ? dayjs(s.scheduledStartTimeMoment).subtract(1, 'day').isSame('', 'day') : null;
        },
        get scheduledTimeDiffFromNow() {
            var _a;
            return (_a = s.scheduledStartTimeMoment) === null || _a === void 0 ? void 0 : _a.diff(s.now);
        },
        get scheduledTimeDiffFromNowFormatted() {
            return s.scheduledTimeDiffFromNow ? humanizeDuration(s.scheduledTimeDiffFromNow) : null;
        },
        get actualStartTimeDiffFromNow() {
            var _a;
            return (_a = s.actualStartTimeMoment) === null || _a === void 0 ? void 0 : _a.diff(s.now);
        },
        get actualStartTimeDiffFromNowFormatted() {
            return s.actualStartTimeDiffFromNow ? humanizeDuration(s.actualStartTimeDiffFromNow) : null;
        },
        get isScheduledInThePast() {
            var _a;
            return (_a = s.scheduledStartTimeMoment) === null || _a === void 0 ? void 0 : _a.isBefore(s.now);
        },
        get isScheduledInTheFuture() {
            return !s.isScheduledInThePast;
        },
        get hasStarted() {
            return !!p.model.timeStarted;
        },
        get isTodayOrFuture() {
            return p.model.timeScheduled ? dayjs.utc(p.model.timeScheduled).local().isSameOrAfter(CLOCK.todayLocalDate, 'day') : false;
        },
        get didntStart() {
            return p.model.timeScheduled && !p.model.timeStarted && dayjs(p.model.timeScheduled).add(1, 'hour').isBefore('');
        },
        get isUpcoming() {
            return Boolean(s.isTodayOrFuture && !p.model.timeStarted && !s.didntStart && !p.model.timeEnded && !p.model.timeArchived && !p.model.timeDeleted);
        },
        // get isUpccoming() {
        //   if (isCounsellingSessionModel(p.model)) {
        //     return p.model.application?.nextSession === p.model || (s.isToday && !p.model.timeEnded);
        //   } else if (isSupportGroupModel(p.model)) {
        //     return p.model.isUpcoming;
        //   }
        // },
        get startingTagContent() {
            if (s.hasStarted) {
                if (!p.model.timeEnded)
                    return "Started " + s.actualStartTimeDiffFromNowFormatted + " ago";
                return React.createElement(React.Fragment, null,
                    "Started on ",
                    React.createElement(DateRenderer, { value: p.model.timeStarted, format: 'LLL' }));
            }
            if (s.isToday && s.isUpcoming)
                return s.isScheduledInThePast ? "Scheduled to start " + s.scheduledTimeDiffFromNowFormatted + " ago" : "Starting in " + s.scheduledTimeDiffFromNowFormatted;
            return undefined;
        },
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('SessionOrGroupTimeDisplay', p.className) },
            React.createElement("time", { className: "SessionOrGroupTimeDisplayTime" }, s.scheduledStartTimeFormatted),
            React.createElement("time", { className: "SessionOrGroupTimeDisplayDate" }, s.startingTagContent ? React.createElement(React.Fragment, null,
                s.scheduledStartDateFormatted,
                React.createElement("div", { className: "SessionOrGroupTimeDisplayDateStartingTag" },
                    React.createElement("span", null, s.startingTagContent),
                    React.createElement("br", null))) : React.createElement(React.Fragment, null,
                s.isToday && React.createElement(React.Fragment, null,
                    "Today, ",
                    React.createElement("br", null)),
                s.isTomorrow && React.createElement(React.Fragment, null,
                    "Tomorrow, ",
                    React.createElement("br", null)),
                s.scheduledStartDateFormatted)))); } });
};
export default SessionOrGroupTimeDisplay;
